import { queryOptions } from '@tanstack/react-query'

import { StoreService } from '@inter-ikea-kompis/core/services'
import type { IDexfSettings, IStore } from '@inter-ikea-kompis/core/types'

import { KOMPIS_SERVICE_BASE_SETTINGS } from '@/integrations/kompis/constants'
import { getCountryFromPath } from '@/utils/base-path-params'

export function storesQueryOptions(dexfSettings: IDexfSettings) {
  return queryOptions({
    queryFn: async () => await fetchStores(dexfSettings),
    queryKey: ['stores', getCountryFromPath()],
    staleTime: Infinity,
  })
}

async function fetchStores(dexfSettings: IDexfSettings): Promise<IStore[]> {
  const storeService = new StoreService({
    ...KOMPIS_SERVICE_BASE_SETTINGS,
    settings: dexfSettings,
  })

  const stores = await storeService.getStores()

  return stores
}
